export const VARIANT_LINK = 'link';
export const VARIANT_PRIMARY = 'primary';
export const VARIANT_PRIMARY_SUBDUED = 'primarySubdued';
export const VARIANT_SECONDARY = 'secondary';
export const VARIANT_SECONDARY_SUBDUED = 'secondarySubdued';
